import { render } from "./TransactionsModal.vue?vue&type=template&id=0cb31b08&scoped=true"
import script from "./TransactionsModal.vue?vue&type=script&lang=js"
export * from "./TransactionsModal.vue?vue&type=script&lang=js"

import "./TransactionsModal.vue?vue&type=style&index=0&id=0cb31b08&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb31b08"]])

export default __exports__